import { Dispatch } from '@reduxjs/toolkit';
import { quilttApi } from 'store/api';
import { apiSlice } from './apiSlice';
import {
  IQuilttSession,
  ICreateSessionParams,
  IGetStatusResponse,
  IQuilttConnection,
  IUpdateQuilttConnectionParams,
} from 'api/digifi/QuilttApi';
import { createNotification } from 'handlers/notificationsSlice';

const QUILTT_ERROR_MESSAGE = 'Unable to connect. Please try again later.';

const createQuilttErrorNotification = (dispatch: Dispatch) => {
  createNotification({
    type: 'error',
    notification: QUILTT_ERROR_MESSAGE,
    dispatch,
  });
};

export const quilttApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createQuilttSession: builder.mutation<
      IQuilttSession,
      ICreateSessionParams
    >({
      queryFn: async (params: ICreateSessionParams, { dispatch }) => {
        try {
          const data = await quilttApi.createSession(params);

          return { data };
        } catch (error) {
          createQuilttErrorNotification(dispatch);

          return { error };
        }
      },
    }),
    updateQuilttConnection: builder.mutation<
     IQuilttConnection,
     IUpdateQuilttConnectionParams
    >({
      queryFn: async (params: IUpdateQuilttConnectionParams, { dispatch }) => {
        try {
          const data = await quilttApi.updateConnection(params);

          return { data };
        } catch (error) {
          createQuilttErrorNotification(dispatch);

          return { error };
        }
      },
    }),
    getQuilttConnection: builder.query<
      IQuilttConnection,
      void
    >({
      queryFn: async () => {
        try {
          const data = await quilttApi.getConnection();

          return { data };
        } catch (error) {
          return { error };
        }
      },
    }),
    getQuilttStatus: builder.query<
      IGetStatusResponse,
      void
    >({
      queryFn: async () => {
        try {
          const data = await quilttApi.getStatus();

          return { data };
        } catch (error) {
          return { error };
        }
      },
    }),
  }),
});

export const {
  useGetQuilttConnectionQuery,
  useCreateQuilttSessionMutation,
  useGetQuilttStatusQuery,
  useUpdateQuilttConnectionMutation,
} = quilttApiSlice;
